import { CRS } from "./CRS";
import key from "url:../../../assets/cursors/KeyCursor-red.png";

export function KY2 () {
    return <CRS>
        <img src={key} className='mcs-icon' />
    </CRS>
}